export const colors = {
  main: "#05070E",
  highlight: "#1EFE5E",
  lowlight: "#0F1823",
  color: "#FFF",
  secondaryColor: "#6C7176",
  alert: "red",
};
